import { regionUI } from 'lib/region-ui';

class ToolbarUI {
  setCanvas(canvas) {
    this.canvas = canvas;
  }

  showAddRelationshipCardOption() {
    if (this.canvas.getSelectedNodes().length) return false;
    if (this.canvas.getSelectedLinks().length == 0) return false;
    if (this.canvas.getSelectedLinks().some(l => !l.linkNode())) return true;
    return false;
  }

  showDetachRelationshipCard() {
    if (this.canvas.getSelectedNodes().length == 0) return false;
    if (this.canvas.getSelectedNodes().some(n => n.link())) return true;
    return false;
  }

  showPartOptions() {
    const nodes = canvas.getSelectedNodes();
    if (!nodes.length) return false;
    if (nodes.some(n => n.children().length)) return true;
    return false;
  }

   /* only one card selected */
  isCardTarget() {
    if (this.canvas.getSelectedLinks().length) return false;
    if (this.canvas.getSelectedNodes().length == 1) return true;
    return false;
  }

  /* only two cards selected */
  isTwoCardTarget() {
    if (this.canvas.getSelectedLinks().length) return false;
    if (this.canvas.getSelectedNodes().length == 2) return true;
    return false;
  }

  /* only one top level card with parts selected */
  isSystemTarget() {
    if (this.canvas.getSelectedLinks().length) return false;
    if (this.canvas.getSelectedNodes().length == 0) return false;

    if (this.canvas.getSelectedNodes().some(n => n.children().length > 0)) return true;
    return false;
  }

  /* parts or R cards selected */
  isAttachedCardTarget() {
    if (this.canvas.getSelectedLinks().length) return false;
    if (this.canvas.getSelectedNodes().length == 0) return false;
    if (this.canvas.getSelectedNodes().every(n => n.parentId || n.link())) return true;
    return false;
  }

  /* only relationships selected */
  isRelationshipTarget() {
    if (this.canvas.getSelectedNodes().length) return false;
    if (this.canvas.getSelectedLinks().length) return true;
  }
  /* multiple cards and 1 or more relationships */
  isMixedSelectionTarget () {
    if (this.canvas.getSelectedNodes().length && this.canvas.getSelectedLinks().length) return true;
  }

  getToolbarTargetClass() {
    if (this.isAttachedCardTarget()) return 'attached-card-target';
    if (this.isSystemTarget()) return 'system-target';
    if (this.isCardTarget()) return 'card-target';
    if (this.isTwoCardTarget()) return 'two-card-target';
    if (this.isRelationshipTarget()) return 'relationship-target';
    if (this.isMixedSelectionTarget()) return 'mixed-selection-target';
  }

  isRegionTarget() {
    return regionUI.getSelectedRegionIds().size > 0;
  }

  isMultiRegionTarget() {
    return regionUI.getSelectedRegionIds().size > 1;
  }

  isSubmenuOpen() {
    const canvas = this.canvas;
    return canvas.linkDirectionMenu.isOpen ||
      canvas.nodePerspectivesPanelTag.isOpen ||
      canvas.nodeAttributeEditor.isOpen ||
      canvas.nodeAlignmentPanelTag.isOpen ||
      canvas.nodeLayoutMenuTag.isOpen ||
      canvas.exportMenu.isOpen ||
      canvas.toolbarViewMoreMenu.isOpen ||
      (canvas.bulkActionsMenuTag.getRelationshipStylePickerTag() && canvas.bulkActionsMenuTag.getRelationshipStylePickerTag().isOpen) ||
      (canvas.bulkActionsMenuTag.getCardStylePickerTag() && canvas.bulkActionsMenuTag.getCardStylePickerTag().isOpen);
  }
}
const tui = new ToolbarUI();

export { ToolbarUI, tui };



// WEBPACK FOOTER //
// ./starling/src/lib/toolbar-ui.js